module.exports = __webpack_public_path__ + "static/media/tablet@2x.4913174c.png";